import { ToolbarOptions } from './types';

const icons = {
  [ToolbarOptions.FullScreenOn]: 'M16 3H22V9H20V5H16V3ZM2 3H8V5H4V9H2V3ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z',
  [ToolbarOptions.FullScreenOff]:
    'M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z',
};

export default icons;
